/* eslint-disable react/require-default-props */
import React from 'react';

import { Container } from './styles';

interface LockedOverlayProps {
  children: React.ReactNode;
  variant?: 'card' | 'inline';
  className?: string;
}

const LockedOverlay: React.FC<LockedOverlayProps> = ({
  children,
  variant = 'card',
  className = '',
}) => {
  return (
    <Container className={`locked-overlay variant-${variant} ${className}`} aria-disabled="true">
      <div className="locked-content">{children}</div>
      <span className="lock-badge" aria-label="Recurso bloqueado">
        <i className="material-icons-outlined">lock</i>
      </span>
    </Container>
  );
};

export default LockedOverlay;
